import { render, staticRenderFns } from "./RectificarIcon.vue?vue&type=template&id=797102cc&scoped=true"
var script = {}
import style0 from "./RectificarIcon.vue?vue&type=style&index=0&id=797102cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797102cc",
  null
  
)

export default component.exports